import { UzButton } from '@utazzo/ui';
import React from 'react';

export interface DataGridErrorProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
}

/**
 * Default error state. Retry button only renders when onRetry is provided.
 */
export const DataGridError = ({
  title = 'Failed to load',
  description = 'Try again or check your network connection.',
  onRetry,
}: DataGridErrorProps): React.JSX.Element => (
  <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
    <p className="text-sm font-medium text-[var(--fg)]">{title}</p>
    <p className="mt-1 max-w-sm text-sm text-[var(--fg-muted)]">{description}</p>
    {onRetry && (
      <div className="mt-4">
        <UzButton variant="secondary" size="sm" onClick={onRetry}>
          Try again
        </UzButton>
      </div>
    )}
  </div>
);
